module.exports = __webpack_public_path__ + "assets/avax-logo.77567361.svg";